import { render, staticRenderFns } from "./shenqingshu.vue?vue&type=template&id=2c4936d8&"
import script from "./shenqingshu.vue?vue&type=script&lang=js&"
export * from "./shenqingshu.vue?vue&type=script&lang=js&"
import style0 from "./shenqingshu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports